import { Month } from './month';

/*
 * Months list.
 */
export const Months: Month[] = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
].map((name: string, index: number) => ({ name: name, number: index + 1 }) as Month);
